import { CartAddEvent } from '@theme/events';

if (!window.__mapisCartBoost) {
  window.__mapisCartBoost = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SKIP_KEY = 'mcb-care-skipped';
  const SKIN_EXP_KEY = 'mcb-skin15-offer-exp';
  const OFFER_MS = 2 * 60 * 1000;

  const ss = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };

  if (ss.get(SKIP_KEY) === '1') document.documentElement.classList.add('mcb-care-skipped');

  const getSectionId = () => {
    const el =
      document.querySelector('cart-items-component[data-drawer]') ||
      document.querySelector('cart-items-component');
    return el ? el.dataset.sectionId : null;
  };

  const showError = (scope, msg) => {
    const err = scope && scope.querySelector('[data-mcb-error]');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  };

  const postJSON = (url, body) =>
    fetch(`${root}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(async (res) => {
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'error');
      return data;
    });

  /* ---------- Oferta Ring Skin: 2 minutos por sesión (arranca cuando el cliente ve la tarjeta) ---------- */
  const offerLeft = () => {
    const exp = parseInt(ss.get(SKIN_EXP_KEY) || '0', 10);
    return exp ? exp - Date.now() : null; // null = aún no arranca
  };

  function tickOffer() {
    document.querySelectorAll('[data-mcb-skin]').forEach((card) => {
      const visible = card.offsetParent !== null;
      if (visible && !ss.get(SKIN_EXP_KEY)) ss.set(SKIN_EXP_KEY, String(Date.now() + OFFER_MS));

      const left = offerLeft();
      const expired = left !== null && left <= 0;
      card.classList.toggle('is-expired', expired);
      card.classList.toggle('is-urgent', !expired && left !== null && left <= 30000);

      const t = card.querySelector('[data-mcb-timer]');
      if (t) {
        const ms = left === null ? OFFER_MS : Math.max(0, left);
        const s = Math.ceil(ms / 1000);
        t.textContent = `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
      }
      const bar = card.querySelector('[data-mcb-progress]');
      if (bar) bar.style.transform = `scaleX(${left === null ? 1 : Math.max(0, left) / OFFER_MS})`;
      syncLabel(card);
    });
  }
  function offerActive(card) {
    return !!card && card.hasAttribute('data-mcb-skin') && !card.classList.contains('is-expired');
  }

  function syncLabel(card) {
    const label = card.querySelector('[data-mcb-add-selected] span');
    const input = card.querySelector('input[type="radio"]:checked');
    if (!label || !input) return;
    // Tarjeta de un solo producto (sin opciones): el botón solo dice "Agregar"
    if (card.hasAttribute('data-mcb-plain')) { if (label.textContent !== 'Agregar') label.textContent = 'Agregar'; return; }
    const price = offerActive(card) && input.dataset.priceOff ? input.dataset.priceOff : input.dataset.price;
    const text = `Agregar ${input.dataset.name} · ${price}`;
    if (label.textContent !== text) label.textContent = text;
  }

  /* ---------- Agregar al carrito ---------- */
  async function addFromCard(card, btn) {
    const checked = card.querySelector('input[type="radio"]:checked');
    const id = checked ? parseInt(checked.value, 10) : 0;
    if (!id) return;

    const sectionId = getSectionId();
    const sectionParams = sectionId ? { sections: sectionId, sections_url: window.location.pathname } : {};
    const code = offerActive(card) ? card.dataset.mcbCode : null;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      let data = await postJSON('cart/add.js', { items: [{ id, quantity: 1 }], ...(code ? {} : sectionParams) });

      if (code) {
        const current = await fetch(`${root}cart.js`).then((r) => r.json());
        const codes = (current.discount_codes || []).map((d) => d.code).filter((c) => c && c !== code);
        codes.push(code);
        data = await postJSON('cart/update.js', { discount: codes.join(','), ...sectionParams });
      }

      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      document.dispatchEvent(
        new CartAddEvent(cart, 'mapis-cart-boost', {
          source: 'mapis-cart-boost',
          itemCount: cart.item_count,
          sections: data.sections || {},
        })
      );
    } catch (e) {
      console.error('[MAPIS Cart Boost]', e);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      showError(card, 'No se pudo agregar. Intenta de nuevo.');
    }
  }

  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const card = input.closest('[data-mcb-upsell]');
    if (card) syncLabel(card);
  });

  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const addBtn = target.closest('[data-mcb-add-selected]');
    if (addBtn) {
      e.preventDefault();
      const card = addBtn.closest('[data-mcb-upsell]');
      if (card) addFromCard(card, addBtn);
      return;
    }

    if (target.closest('[data-mcb-skip-care]')) {
      e.preventDefault();
      document.documentElement.classList.add('mcb-care-skipped');
      ss.set(SKIP_KEY, '1');
      tickOffer();
    }
  });

  /* ---------- Botón de pago: directo al checkout ----------
     Se ejecuta en captura sobre window para que ninguna app (p. ej. UpCart)
     pueda interceptar o bloquear el clic. El carrito ya vive en el servidor,
     así que /checkout lleva todos los productos y descuentos. */
  window.addEventListener(
    'click',
    (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest('#checkout, .cart__checkout-button');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      btn.classList.add('is-loading');
      window.location.href = `${root}checkout`;
    },
    true
  );

  // Arranca el timer al final, cuando todo ya está definido
  setInterval(tickOffer, 1000);
  tickOffer();
}
